/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import _ from 'lodash';

import { RoleAction, Member } from '@wix/members-domain-ts';

import MoreButton from '../more-button';
import PopoverContent from './popover-content';
import { POSITION } from '../../constants/positioning';

interface Props {
  containerClass: string;
  member: Member;
  rolesActions: RoleAction[];
  onRoleAction: Function;
  dynamicPositioning?: boolean;
  iconContainerClass?: string;
  position?: POSITION;
  isRtlLocale: boolean;
  ariaLabel?: string;
}

const MemberMoreButton: React.StatelessComponent<Props> = ({
  containerClass,
  member,
  rolesActions,
  onRoleAction,
  dynamicPositioning = false,
  iconContainerClass = '',
  position,
  isRtlLocale,
  ariaLabel,
}) => {
  const renderMoreButton = () => {
    const menuId = `menu-${member.uid}`;

    return (
      <div className={containerClass} data-hook="memberMoreButton">
        <MoreButton
          iconContainerClass={iconContainerClass}
          dynamicPositioning={dynamicPositioning}
          position={position}
          isRtlLocale={isRtlLocale}
          ariaLabel={ariaLabel}
          menuId={menuId}
        >
          <PopoverContent rolesActions={rolesActions} member={member} onRoleAction={onRoleAction} />
        </MoreButton>
      </div>
    );
  };

  const renderEmpty = () => {
    return null;
  };

  return _.isEmpty(rolesActions) ? renderEmpty() : renderMoreButton();
};

export default MemberMoreButton;
